import {css} from '@yandex-delivery/blocks/theme/css'

export const trail = css`
  width: auto;
`

export const link = css`
  text-decoration: none;
`
